import React from 'react';
import PageHeader from "../Components/page_header";
import PortfoliosTab from "../Components/portfolios";
import Testimonials from "../Components/testimonials";
import Layout from "../Layouts";

export default function Portfolios() {
    return (
        <Layout>
            <PageHeader title="Portfolios" />
            <PortfoliosTab/>
            <Testimonials/>
        </Layout>
    )
}
